import { useCallback } from 'react';
import { useHttpClient } from '../../client/HttpClientContext';
import { useAsyncFunction } from '../../utils/hooks/useAsyncFunction';
import { hubsSettingsCache } from '../../cache';
export const useSavingMode = (options = {}) => {
  const httpClient = useHttpClient();
  const getSavingMode = useCallback(async () => {
    const setting = await hubsSettingsCache.get({
      settingName: 'CRM:Properties:AutosaveMode',
      defaultValue: 'auto'
    }, httpClient);
    return setting;
  }, [httpClient]);
  return useAsyncFunction(getSavingMode, options);
};